import NavbarUA from "../components/NavbarUA";
import FooterUA from "../components/FooterUA";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { FadeIn } from "../components/AnimationWrapper";
import { useRef } from "react";
import { Helmet } from "react-helmet-async";

export default function ContactUA() {
  const heroHeadingRef = useRef(null);

  return (
    <>
      <NavbarUA heroHeadingRef={heroHeadingRef} />
      <Helmet>
        <html lang="uk" />
        <title>Контакти – CV Box | Зв'яжіться з нами</title>
        <meta name="description" content="Маєте запитання щодо CV Box? Напишіть нашій команді підтримки. Допомога з оптимізацією CV, ATS-перевіркою, трекінгом вакансій та AI-коучингом." />
        <link rel="canonical" href="https://cv-box.com/ua/contact" />
      </Helmet>

      <main>
        <section className="pt-32 lg:pt-44 pb-20 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] min-h-[40vh] flex items-center">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <FadeIn>
              <h1 ref={heroHeadingRef} className="text-4xl lg:text-5xl font-bold text-white mb-4">Зв'яжіться з нами</h1>
              <p className="text-white/60 text-lg max-w-xl mx-auto">
                Маєте запитання або потрібна допомога? Ми завжди раді відповісти.
              </p>
            </FadeIn>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-2xl mx-auto px-6">
            <FadeIn>
              <div className="bg-white rounded-2xl p-8 shadow-feature-card">
                <h2 className="text-2xl font-medium text-gray-900 mb-6">Напишіть нам</h2>
                <div className="space-y-6">
                  <div>
                    <p className="text-gray-700 text-lg mb-2">📧 Email підтримки:</p>
                    <a href="mailto:support@cv-box.com" className="text-indigo-600 text-lg font-medium hover:text-indigo-700">support@cv-box.com</a>
                  </div>
                  <div>
                    <p className="text-gray-700 text-lg mb-2">⏱ Час відповіді:</p>
                    <p className="text-gray-600">Зазвичай відповідаємо протягом 24 годин у робочі дні.</p>
                  </div>
                  <div>
                    <p className="text-gray-700 text-lg mb-2">💬 Теми, з якими допомагаємо:</p>
                    <ul className="text-gray-600 space-y-2 list-disc list-inside">
                      <li>Оптимізація CV та ATS-перевірка</li>
                      <li>Покупка кредитів та оплата</li>
                      <li>Технічні проблеми з платформою</li>
                      <li>Пропозиції щодо нових функцій</li>
                      <li>Партнерство та бізнес-запити</li>
                    </ul>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
      </main>

      <ScrollToTopButton />
      <FooterUA />
    </>
  );
}
